<template>
	<div></div>
</template>

<script>
export default {
	name: 'SaveTheRouteList',
	setup() {},
}
</script>

<style lang="scss" scoped></style>
